import { render, staticRenderFns } from "./DialogReportQuestion.vue?vue&type=template&id=aa01f04a&scoped=true"
import script from "./DialogReportQuestion.vue?vue&type=script&lang=js"
export * from "./DialogReportQuestion.vue?vue&type=script&lang=js"
import style0 from "./DialogReportQuestion.vue?vue&type=style&index=0&id=aa01f04a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa01f04a",
  null
  
)

export default component.exports